import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useRef, useState, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import Progress from '../ui/react-ui/progress.jsx';
import ModalDialog from '../ui/modal-dialog';
import Form from '../ui/form';
import Textarea from '../ui/textarea'; // Api

import { editFeedbackAPI } from '../../api/settingAPI';
var t = i18n.getFixedT(null, 'setting-feedback');
var gt = i18n.getFixedT(null, 'app');
var et = i18n.getFixedT(null, 'errors');
var FeedbackEdit = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot;

  var id = props.id,
      onClose = props.onClose,
      _props$dialogData = props.dialogData,
      mode = _props$dialogData.mode,
      data = _props$dialogData.data;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      formData = _useState2[0],
      setFormData = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var form_ref = useRef(null);

  var resetState = function resetState() {
    setFormData({});
    setError();
  };

  var handleChange = function handleChange(value, path) {
    var newData = _.cloneDeep(formData);

    _.set(newData, path, value);

    setFormData(newData);
    setError();
  };

  var handleClose = function handleClose() {
    resetState();
    onClose();
  };

  var handleConfirm = function handleConfirm() {
    Progress.startSpin();
    editFeedbackAPI(contextRoot, true, formData.description).then(function (result) {
      resetState();
      onClose('confirm');
    }).catch(function (error) {
      Progress.done();
      setError(et(error.messageCode) === _.toString(error.messageCode) ? error.message : et(error.messageCode));
    });
  };

  useEffect(function () {
    if (_.isEmpty(mode)) setFormData(data);
  }, [mode]);
  if (_.isEmpty(mode)) return null;
  var actions = {};

  _.set(actions, 'cancel', {
    text: mode === 'edit' ? gt('global.lbl-answer-cancel') : gt('global.lbl-close'),
    handler: handleClose
  });

  if (mode === 'edit') {
    _.set(actions, 'confirm', {
      text: gt('global.lbl-answer-ok'),
      className: 'button-success',
      handler: handleConfirm
    });
  }

  var fields = {};

  _.set(fields, 'description', {
    label: '',
    formatter: function formatter(val, row) {
      if (mode === 'read') return /*#__PURE__*/React.createElement("div", {
        className: "preline"
      }, val);
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Textarea, {
        onChange: function onChange(val) {
          return handleChange(val, 'description');
        },
        value: val,
        validate: {
          required: true,
          t: function t(code) {
            return et("txt-".concat(code));
          }
        }
      }));
    }
  });

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: t("dlg-feedback-".concat(mode)),
    global: true,
    info: error,
    infoClassName: cx({
      'c-error': error
    }),
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement(Form, {
    id: "".concat(id, "-form"),
    ref: form_ref,
    className: "pure-form-aligned",
    fieldClassName: "pure-control-group",
    fields: fields,
    onChange: handleChange,
    value: _.isEmpty(formData) ? data : formData
  }));
});
FeedbackEdit.defaultProps = {
  id: 'g-feedback-edit'
};
FeedbackEdit.propTypes = {
  id: PropTypes.string
};
export default FeedbackEdit;